import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { BathroomCollections } from 'landings/bathroom-collections';
import { RemoteProps } from './widgets-types';

export const BathroomCollectionsRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <BathroomCollections />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
